import { z } from 'zod'
import { clockTime } from './time-entry'
import { clockDurationMinutes } from './time'

export const timeEntryDayClipboardEntry = z
  .object({
    personId: z.string().min(1),
    projectId: z.string().min(1),
    taskId: z.string().min(1).nullable(),
    startTime: clockTime,
    endTime: clockTime,
    description: z.string().trim().min(1).max(500).nullable(),
    billable: z.boolean(),
    display: z
      .object({
        person: z.string().min(1),
        project: z.string().min(1),
        task: z.string().min(1).nullable()
      })
      .strict()
  })
  .strict()
  .refine((entry) => clockDurationMinutes(entry.startTime, entry.endTime) !== null, {
    message: 'Start time must be earlier than end time.'
  })

export const timeEntryDayClipboard = z
  .object({
    type: z.literal('com.coneno.c-sheet.time-entry-day'),
    schemaVersion: z.literal(2),
    payloadId: z.uuid(),
    copiedAt: z.iso.datetime(),
    source: z.object({ workDate: z.iso.date() }).strict(),
    entries: z.array(timeEntryDayClipboardEntry).min(1).max(500)
  })
  .strict()
export type TimeEntryDayClipboard = z.infer<typeof timeEntryDayClipboard>

export const timeEntryDayDate = z.iso.date()

export const pasteDayInput = z.object({
  workDate: timeEntryDayDate,
  payload: timeEntryDayClipboard
})
export type PasteDayInput = z.infer<typeof pasteDayInput>
